import buildAndroid from './android';
import buildIOS from './ios';

export default {
  ios: buildIOS,
  android: buildAndroid,
};
